<script lang="ts">
  import { getStr } from '../../../common/util';
  import Icon from '../../common/components/Icon.svelte';
  import Text from '../../common/components/Text.svelte';

  export let basketPromotions: any = [];
</script>

{#if basketPromotions?.length}
  <section class="basket-offer-wrapper">
    <div class="wrapper">
      <div class="basket-offer-title">
        <Text key="extra.basket.promotion.pdp.title" />
      </div>
      <div class="offers-wrapper">
        {#each basketPromotions as basketProm}
          <div class="offer-wrapper">
            <Icon type="url" desktopSize={36} mobileSize={24} glyph={getStr('extra.promotion.icon.url')} />
            <div class="message-wrapper">
              {#if basketProm?.description}
                <div class="description">
                  {@html basketProm?.description}
                </div>
              {/if}
              {#if basketProm?.subText}
                <div class="sub-des">
                  {@html basketProm?.subText}
                </div>
              {/if}
            </div>
            <!-- <div class="basket-offer-link">
                        Shop Smartphones
                    </div> -->
          </div>
        {/each}
      </div>
    </div>
  </section>
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .basket-offer-wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(0, auto);
    background-color: $primary-white;
    @include desktop-min-width {
      max-width: 1440px;
    }
    .offers-wrapper {
      display: flex;
      flex-direction: column;
      gap: 20px;
      @include desktop-max-width {
        gap: 8px;
      }
    }
    .wrapper {
      display: flex;
      flex-direction: column;
    }
    .basket-offer-title {
      color: $neutral-dark-01;
      font-weight: 700;
      font-size: 22px;
      line-height: 24px;
      margin-bottom: 24px;
      @include desktop-min-width {
        font-size: 36px;
        line-height: 40px;
        margin-bottom: 32px;
      }
    }
    .offer-wrapper {
      display: flex;
      gap: 24px;
      background: $neutral-light-04;
      padding: 35px 22px 37px;
      border-radius: 20px;
      align-items: center;
      @include desktop-max-width {
        gap: 16px;
        padding: 24px 8px;
      }
    }
    .message-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;
      .description {
        color: $neutral-dark-01;
        font-size: 24px;
        font-weight: 500;
        line-height: 26px;
        :global(p) {
          margin: 0;
          color: $neutral-dark-01;
          font-size: 24px;
          font-weight: 500;
          line-height: 26px;
        }
      }
      .sub-des {
        color: $neutral-dark-02;
        font-size: 20px;
        font-weight: 400;
        line-height: 22px;
        :global(p) {
          margin: 0;
          color: $neutral-dark-02;
          font-size: 20px;
          font-weight: 400;
          line-height: 22px;
        }
      }
    }
    .basket-offer-link {
      color: $primary-blue;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
    }
  }
</style>
